module.exports = __webpack_public_path__ + "img/Mietzekatze.fe451203.jpg";